<template>
    <accordion>
        <accordion-item :force-active="expanded" @open="toggle" class="mb-4">
            <!-- This slot will handle the title/header of the accordion and is the part you click on -->
            <template slot="accordion-trigger">
                <span class="number">1</span>
                <h4>dados da entrega</h4>
            </template>
            <!-- This slot will handle all the content that is passed to the accordion -->
            <template slot="accordion-content">
                <form class="checkout-form">
                    <div class="flex">
                        <div class="pr-3.5 w-full">
                            <label class="font-body">Refeição</label>
                            <div class="input-box">
                                <input
                                    type="text"
                                    class="form-control input-blocked disabled"
                                    :disabled="true"
                                    v-model="mealTime"
                                    placeholder="Refeição"
                                />
                            </div>
                        </div>
                        <div class="pr-3.5 w-full">
                            <label class="text-gray uppercase font-semibold"
                                >Tipo de encomenda*</label
                            >
                            <div class="input-box">
                                <input
                                    type="text"
                                    class="form-control input-blocked disabled"
                                    :disabled="true"
                                    v-model="orderType"
                                    placeholder="Tipo de encomenda"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="flex mt-6 pr-3.5">
                        <div class="pr-3.5 w-full">
                            <label class="text-gray uppercase font-semibold"
                                >Pauzinhos</label
                            >
                            <div class="input-box">
                                <input
                                    type="text"
                                    class="form-control input-blocked disabled"
                                    :disabled="true"
                                    v-model="numUtensils.label"
                                    placeholder="Pauzinhos"
                                />
                            </div>
                        </div>
                        <div class="form-group input-container w-full">
                            <label class="font-body">Sojas (15ml)</label>
                            <div class="input-box">
                                <input
                                    type="text"
                                    class="form-control input-blocked disabled"
                                    :disabled="true"
                                    v-model="numSoy.label"
                                    placeholder="Sojas (15ml)"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="flex mt-6">
                        <div class="pr-3.5 w-full">
                            <label class="text-gray uppercase font-semibold"
                                >Dia</label
                            >
                            <div class="select-container">
                                <multiselect
                                    :options="optionsDates"
                                    v-model="date"
                                    :default-val="defaultValDates"
                                    :is-form="true"
                                    :is-checkout="true"
                                    :name="eventNameDates"
                                ></multiselect>
                            </div>
                            <span
                                class="text-danger error"
                                v-if="
                                    checkoutFormError.date &&
                                        checkoutFormError.date.length > 0
                                "
                                >{{ checkoutFormError.date[0] }}</span
                            >
                        </div>
                        <div class="form-group input-container w-full">
                            <label class="text-gray uppercase font-semibold"
                                >horário</label
                            >
                            <div class="select-container">
                                <multiselect
                                    :is-form="true"
                                    :options="slotOptions"
                                    v-model="schedule"
                                    :default-val="defaultValSlots"
                                    :is-checkout="true"
                                    :name="eventNameSlots"
                                >
                                </multiselect>
                            </div>
                            <span
                                class="text-danger error"
                                v-if="
                                    checkoutFormError.schedule &&
                                        checkoutFormError.schedule.length > 0
                                "
                                >{{ checkoutFormError.schedule[0] }}</span
                            >
                        </div>
                    </div>

                    <div class="divisor"></div>

                    <div class="form-group input-container">
                        <label class="font-body"> morada* </label>

                        <div class="input-box">
                            <input
                                type="text"
                                class="form-control"
                                v-model="street"
                                placeholder="Morada"
                                :class="{
                                    'input-blocked disabled': orderAddressDisabled
                                }"
                            />
                            <span
                                class="text-danger error"
                                v-if="
                                    checkoutFormError.street &&
                                        checkoutFormError.street.length > 0
                                "
                                >{{ checkoutFormError.street[0] }}</span
                            >
                        </div>
                    </div>
                    <div class="flex mt-6">
                        <div class="form-group input-container pr-3.5">
                            <label class="font-body"> Número* </label>

                            <div class="input-box">
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="door"
                                    placeholder="Número"
                                    :class="{
                                        'input-blocked disabled': orderAddressDisabled
                                    }"
                                />
                                <span
                                    class="text-danger error"
                                    v-if="
                                        checkoutFormError.door &&
                                            checkoutFormError.door.length > 0
                                    "
                                    >{{ checkoutFormError.door[0] }}</span
                                >
                            </div>
                        </div>
                        <div class="form-group input-container pr-3.5">
                            <label class="font-body"> Andar </label>

                            <div
                                class="input-box"
                                :class="{
                                    xpto:
                                        checkoutFormError.floor &&
                                        checkoutFormError.floor.length > 0
                                }"
                            >
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="floor"
                                    placeholder="Andar"
                                    :class="{
                                        'input-blocked disabled': orderAddressDisabled
                                    }"
                                />
                                <span
                                    class="text-danger error"
                                    v-if="
                                        checkoutFormError.floor &&
                                            checkoutFormError.floor.length > 0
                                    "
                                    >{{ checkoutFormError.floor[0] }}</span
                                >
                            </div>
                        </div>
                        <div class="form-group input-container">
                            <label class="font-body"> lado </label>

                            <div class="input-box">
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="side"
                                    placeholder="Lado"
                                    :class="{
                                        'input-blocked disabled': orderAddressDisabled
                                    }"
                                />
                                <span
                                    class="text-danger error"
                                    v-if="
                                        checkoutFormError.side &&
                                            checkoutFormError.side.length > 0
                                    "
                                    >{{ checkoutFormError.side[0] }}</span
                                >
                            </div>
                        </div>
                    </div>
                    <div class="flex mt-6">
                        <div class="pr-3.5 w-full">
                            <label class="text-gray uppercase font-semibold"
                                >código postal</label
                            >
                            <div class="input-box">
                                <input
                                    type="text"
                                    class="form-control input-blocked disabled"
                                    :disabled="true"
                                    v-model="zipcode"
                                    placeholder="Codigo Postal"
                                />
                                <span
                                    class="text-danger error"
                                    v-if="
                                        checkoutFormError.side &&
                                            checkoutFormError.side.length > 0
                                    "
                                    >{{ checkoutFormError.side[0] }}</span
                                >
                            </div>
                        </div>
                        <div class="form-group input-container w-full">
                            <label class="font-body"> Localidade* </label>

                            <div class="input-box">
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="locality"
                                    placeholder="Localidade"
                                    :class="{
                                        'input-blocked disabled': orderAddressDisabled
                                    }"
                                />
                                <span
                                    class="text-danger error"
                                    v-if="
                                        checkoutFormError.locality &&
                                            checkoutFormError.locality.length >
                                                0
                                    "
                                    >{{ checkoutFormError.locality[0] }}</span
                                >
                            </div>
                        </div>
                    </div>
                    <div
                        class="mt-6"
                        :class="{
                            hidden:
                                orderAddressObj && orderAddressObj.saved_address
                        }"
                    >
                        <label class="font-body"> guardar morada?* </label>
                        <div class="flex radio-selector address">
                            <div class="radio-container">
                                <input
                                    type="radio"
                                    name="radio"
                                    id="save-yes"
                                    v-model="adressRadio"
                                    value="yes"
                                    checked
                                    :class="{
                                        'input-blocked disabled': orderAddressDisabled
                                    }"
                                />
                                <label class="container" for="save-yes">
                                    <p>Sim</p>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="radio-container">
                                <input
                                    type="radio"
                                    name="radio"
                                    v-model="adressRadio"
                                    value="no"
                                    id="save-no"
                                    :class="{
                                        'input-blocked disabled': orderAddressDisabled
                                    }"
                                />
                                <label class="container" for="save-no">
                                    <p>Não</p>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div
                        class="form-group input-container mt-6"
                        :class="{ hidden: adressRadio == 'no' }"
                    >
                        <label class="font-body"> Nome da morada* </label>

                        <div class="input-box">
                            <input
                                type="text"
                                class="form-control"
                                v-model="alias"
                                placeholder="Nome da morada"
                                :class="{
                                    'input-blocked disabled': orderAddressDisabled
                                }"
                            />
                            <span
                                class="text-danger error"
                                v-if="
                                    checkoutFormError.alias &&
                                        checkoutFormError.alias.length > 0
                                "
                                >{{ checkoutFormError.alias[0] }}</span
                            >
                        </div>

                        <!-- @error('username') <span class="text-danger error">{{ $message }}</span>@enderror -->
                    </div>
                    <div class="input-container mt-6 phone-field">
                        <label>número telefone*</label>
                        <phone-mask
                            :is-form="true"
                            @clearField="customerPhoneNumber = null"
                            :default-country-code="customerPhoneCountryCode"
                            :default-phone-number="customerPhoneNumber"
                            v-model="phone"
                        >
                        </phone-mask>
                        <span
                            class="text-danger error"
                            v-if="
                                checkoutFormError.phone &&
                                    checkoutFormError.phone.length > 0
                            "
                            >{{ checkoutFormError.phone[0] }}</span
                        >
                    </div>

                    <p class="text-info mt-6 mb-3">*campos obrigatórios</p>

                    <button
                        class="btn-bg"
                        :class="{ disabled: isLoading }"
                        type="button"
                        @click="nextStep"
                    >
                        Próximo passo
                    </button>
                </form>
            </template>
        </accordion-item>
    </accordion>
</template>

<script>
import {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,
    VsaIcon
} from "vue-simple-accordion";
// import 'vue-simple-accordion/dist/vue-simple-accordion.css';
import Multiselect from "vue-multiselect";

import Accordion from "./accordion";
import AccordionItem from "./accordion-item";

export default {
    components: {
        "v-multiselect": Multiselect,
        VsaList,
        VsaItem,
        VsaHeading,
        VsaContent,
        VsaIcon,
        Accordion,
        AccordionItem
    },
    props: {
        orderType: {
            required: false
        },
        mealTime: {
            required: false
        },
        optionsExtrasUtensils: {
            required: false
        },
        defaultValExtrasUtensils: {
            required: false,
            default: 0
        },
        eventNameUtensils: {
            required: false
        },
        optionsExtrasSoy: {
            required: false
        },
        defaultValExtrasSoy: {
            required: false,
            default: 0
        },
        eventNameSoy: {
            required: false
        },
        optionsDates: {
            required: false
        },
        defaultValDates: {
            required: false
        },
        eventNameDates: {
            required: false
        },
        optionsSlots: {
            required: false
        },
        defaultValSlots: {
            required: false
        },
        eventNameSlots: {
            required: false
        },
        orderAddressObj: {
            required: false
        },
        orderAddressDisabled: {
            required: false
        },
        customerPhoneCode: {
            required: false
        },
        customerPhoneCountryCode: {
            required: false
        },
        customerPhoneNumber: {
            required: false
        }
    },
    data() {
        return {
            street: this.orderAddressObj.street,
            zipcode: this.orderAddressObj.zipcode,
            door: this.orderAddressObj.door,
            floor: this.orderAddressObj.floor,
            side: this.orderAddressObj.side,
            locality: this.orderAddressObj.locality,
            adressRadio: !this.orderAddressObj.saved_address ? "yes" : "no",
            alias: this.orderAddressObj.alias,
            phone: "",
            numUtensils: {
                key: this.defaultValExtrasUtensils,
                label: parseInt(this.defaultValExtrasUtensils)
            },
            numSoy: {
                key: this.defaultValExtrasSoy,
                label: parseInt(this.defaultValExtrasSoy)
            },
            date: "",
            schedule: "",
            checkoutFormError: {
                num_utensils: [],
                num_soy: [],
                date: [],
                schedule: [],
                street: [],
                door: [],
                floor: [],
                side: [],
                locality: [],
                alias: [],
                phone: []
            },
            expanded: true,
            isLoading: false,
            slotOptions: this.optionsSlots
        };
    },
    mounted() {},
    methods: {
        nextStep() {
            this.isLoading = true;
            this.$axios
                .post("/checkout/address", {
                    num_utensils: this.numUtensils.key,
                    num_soy: this.numSoy.key,
                    date: this.date.key || this.date,
                    schedule: this.schedule.key || this.schedule,
                    street: this.street,
                    door: this.door,
                    floor: this.floor,
                    side: this.side,
                    locality: this.locality,
                    alias: this.alias,
                    save_address: this.adressRadio == "yes",
                    phonecode:
                        (this.phone && this.phone.countryCallingCode) ||
                        this.customerPhoneCode,
                    phone:
                        (this.phone && this.phone.nationalNumber) ||
                        this.customerPhoneNumber,
                    zipcode: this.zipcode
                })
                .then(response => {
                    this.$root.$emit("open-accordion-payment", this.schedule);

                    this.expanded = false;
                    this.isLoading = false;
                })
                .catch(error => {
                    this.checkoutFormError = error.response.data;
                    this.isLoading = false;
                });

            this.$axios.get(`/api/event/paymentInitiated`).catch(error => {
                console.log(error);
            });
        },
        toggle() {
            this.$root.$emit("close-accordion-payment");
        }
    },
    watch: {
        date(newVal, oldVal) {
            if (
                newVal &&
                oldVal &&
                newVal != oldVal &&
                newVal.key != oldVal.key
            ) {
                this.$axios
                    .post("/checkout/date/ajax", {
                        date: newVal.key
                    })
                    .then(response => {
                        this.slotOptions = response.data;
                    })
                    .catch(error => {
                        console.log("DATE SLOT AJAX ERROR: ", error.response);
                    });
            }
        },
        numPeople(newVal, oldVal) {
            if (newVal && oldVal && newVal.key != oldVal.key) {
                this.$axios
                    .post("/checkout/people/ajax", {
                        "num-people": newVal.key
                    })
                    .then(response => {})
                    .catch(error => {});
            }
        },
        numUtensils(newVal, oldVal) {
            if (newVal && oldVal && newVal.key != oldVal.key) {
                this.$axios
                    .post("/checkout/people/ajax", {
                        utensils: newVal.key
                    })
                    .then(response => {})
                    .catch(error => {});
            }
        },
        numSoy(newVal, oldVal) {
            if (newVal && oldVal && newVal.key != oldVal.key) {
                this.$axios
                    .post("/checkout/people/ajax", {
                        soy: newVal.key
                    })
                    .then(response => {})
                    .catch(error => {});
            }
        }
    }
};
</script>

<style></style>
